export const BRAND_LOGO_FALLBACKS: Record<string, string> = {
  "hot wheels": "/logos/brands/hot-wheels.png",
  maisto: "/logos/brands/maisto.png",
  majorette: "/logos/brands/majorette.png",
  "mini gt": "/logos/brands/minigt.svg",
  "pop race": "/logos/brands/poprace.png",
  tarmac: "/logos/brands/tarmac.avif",
};

export function getBrandLogoFallback(brandName: string): string | null {
  const key = brandName.trim().toLowerCase();
  return BRAND_LOGO_FALLBACKS[key] ?? null;
}

